const Moment = require('moment');

const getRoundUpTime = (ms) => {
    const mod = ms % 1000;
    if (mod >= 500) {
        ms = ms + (1000 - mod)
    } else {
        ms = ms - mod;
    }

    return ms;
};

const getTimeFormat = (ms) => {
    ms = getRoundUpTime(ms);
    const date = Moment().startOf('day').add(ms, 'milliseconds');    
    // let timeFormat = date.hours() > 0 ? 'HH:mm:ss' : 'mm:ss';
    return date.format('HH:mm:ss');
};

module.exports = {
    getRoundUpTime,
    getTimeFormat,
};
